<template>
    <div class="vm-comment">
        <div
            class="fsl16 fwb"
            v-if="post.has_right || post.comment_count >= 50"
        >{{$t('c.Comment.text1')}} {{post.comment_count}}</div>
        <div
            class="flex-box flex-align-items-center mt-24-16 mq"
            v-if="!is_hide_my_textarea && is_show_comment_door"
            :class="{'toolbar': is_need_toolbar && browser_size == 'small'}"
        >
            <avatar v-if="session_user" class="wh24" :user="session_user" :is_only_avatar="true"></avatar>
            <textarea-autosize
                class="gl-textarea fs14 ml16"
                v-model="content"
                :placeholder="$t('c.Comment.text2')"
                :init-height="browser_size == 'small' ? 27 : ''"
                :reduce-scroll-height="8"
                :max-height="100"
                @focus.native="open_modal_comment('comment')"
            ></textarea-autosize>
            <btn
                v-if="browser_size != 'small'"
                class="look1 ml16"
                @click.native="publish_comment"
            >{{$t('c.Comment.text3')}}</btn>
            <div class="flex-box flex-align-items-center action-box" v-else-if="is_need_toolbar">
                <div class="line-vertical mr16"></div>
                <like
                    :data="post"
                    @like_success="comment_like_success"
                    @unlike_success="comment_unlike_success"
                ></like>
                <icon-collect class="fs20 ml20" :data="post" @collect_success="collect_success" @uncollect_success="uncollect_success"/>
                <share v-if="!GL.ENV.is_wechat_mini" class="ml20" :config="share_config" :is_only_icon="true"></share>
            </div>
        </div>
        <template v-for="(item,i) in comment_list">
            <avatar
                :key="item.comment_id + i"
                :user="item.user"
                :class="avatar_size ? avatar_size : 'wh24'"
                :is_href_blank="true"
                class="pt24 comment-item"
                :name_width="120">
                <div
                    slot="name-right"
                    class="black-5 flex-item-1 flex-box flex-justify-content-space-between flex-align-items-center"
                >
                    <div class="black-5 ml8 fwn">
                        <template v-if="post && post.user_id == item.user.user_id">{{$t('c.Comment.text4')}}</template>
                        <template v-if="group && group.user_id == item.user.user_id">{{$t('c.Comment.text5')}}</template>
                        <template v-if="subject">{{subject}}</template>
                    </div>
                    <span class="fsl12 black-3" v-text="$time_show(item.publish_time)"></span>
                </div>
                <div slot="info" class="mt4">
                    <div class="clearfix">
                        <div class="fl fs14 lh1_6" v-if="item.reply_user">{{$t('c.Comment.text6')}}
                            <router-link
                                class="ml8 fwb black-3 gl-hover-text-purple underline"
                                :to="$userlink(item.reply_user)"
                            >{{item.reply_user.name}}</router-link>：
                        </div>
                        <pre-box class="fs14" :text="item.content"></pre-box>
                    </div>
                    <div class="flex-box mt4">
                        <like
                            :data="item"
                            @like_success="like_success"
                            @unlike_success="unlike_success"
                        ></like>
                        <div
                            v-if="!item.is_show_reply && (session_user ? session_user.user_id != item.user.user_id : true)"
                            @click="open_reply(item)"
                            class="flex-box flex-align-items-center gl-hover-text-purple black-3 ml16 reply-door hover-bg-purple"
                        >
                            <i class="afd afd-reply fs14 mr4"></i>
                            {{$t('c.Comment.text7')}}
                        </div>
                        <div
                            v-if="item.is_show_reply"
                            class="flex-box flex-align-items-center gl-hover-text-purple black-3 ml16 reply-door hover-bg-purple"
                            @click="close_reply(item)"
                        >
                            <i class="afd afd-x fs12 mr8"></i>
                            {{$t('c.Comment.text8')}}
                        </div>
                        <div
                            v-if="item.can_edit == 1"
                            class="gl-hover-text-purple black-3 ml16 reply-door hover-bg-purple flex-box flex-a-center"
                            @click="delete_comment(item.comment_id)"
                        >{{$t('c.Comment.text9')}}</div>
                    </div>
                    <div class="flex-box mt8" v-if="item.is_show_reply">
                        <textarea-autosize
                            class="gl-textarea fs14"
                            v-model="item.reply_content"
                            :placeholder="`${$t('c.Comment.text10')}${item.user.name}…`"
                            :init-height="27"
                            :max-height="100"
                        ></textarea-autosize>
                        <btn class="look1 ml16" @click.native="publish_reply(item)">{{$t('c.Comment.text11')}}</btn>
                    </div>
                    <slot></slot>
                </div>
            </avatar>
            <div
                class="split-line-box"
                :key="item.comment_id + i + 'hot'"
                v-if="hot_list.length > 0 && i == hot_list.length - 1"
            >
                <div class="line"></div>
                <div class="fs12 black-5 t-box">
                    <div>{{$t('c.Comment.text12')}}</div>
                </div>
            </div>
        </template>
        <div
            v-if="!is_visit_post_page && !is_loading && has_more == 1"
            class="load-more-box flex-box flex-center p_16_0 fs14 black-5 gl-hover-text"
            @click="load_more"
        >{{$t('c.Comment.text13')}}</div>
        <router-link
            v-if="is_visit_post_page && has_more == 1"
            :to="`/p/${post.post_id}`"
            class="load-more-box flex-box flex-center p_16_0 fs14 black-5 gl-hover-text-purple"
        >{{$t('c.Comment.text14')}}</router-link>
        <div v-if="is_loading" class="load-box flex-box flex-center mt16">
            <img style="width: 30px" src="/static/img/asset/loding.png" class="loading">
        </div>
    </div>
</template>

<script>
import {
  POST_COMMENT_PUBLISH,
  GET_COMMENT_GET_LIST,
  POST_COMMENT_DELETE,
  POST_MY_NOTICE
} from "@/api/config";
import { mapState } from "vuex";
export default {
  name: "comment",
  props: {
    is_visit_post_page: {
      type: Boolean,
      default() {
        return false;
      }
    },
    post: {
      type: Object,
      default() {
        return {};
      }
    },
    group: {
      type: Object,
      default() {
        return {};
      }
    },
    is_need_toolbar: {
      type: Boolean,
      default() {
        return false;
      }
    },
    is_hide_my_textarea: {
      type: Boolean,
      default() {
        return false;
      }
    },
    share_config: {
      type: Object,
      default() {
        return {};
      }
    },
    comment: {
      type: Object,
      default() {
        return {};
      }
    },
    subject: {
      type: String,
      default() {
        return "";
      }
    },
    is_hide_reply: {
      type: Boolean,
      default() {
        return false;
      }
    },
    avatar_size: {
      type: String,
      default() {
        return "";
      }
    }
  },
  data() {
    let comment_list = [];
    let new_watch_node = {
      is_show_reply: false,
      reply_content: ""
    };
    if (this.comment.comment_id) {
      comment_list.push(Object.assign({}, new_watch_node, this.comment));
    }
    return {
      content: "",
      reply: "",
      reply_comment_id: "",
      comment_list: comment_list,
      post_data: {},
      new_watch_node: new_watch_node,
      has_more: 0,
      is_loading: false,
      hot_list: [],
      ENV:this.GL.ENV,
      is_show_comment_door: this.$route.params.postId != 'd5477d7c24de11e993d952540025c377',
    };
  },
  computed: {
    ...mapState("app", ["session_user", "browser_size","bind_account"]),
    no_bind_user(){
        return this.bind_account.email == '' && this.bind_account.phone == ''
    },
    no_bind_phone(){
      return this.bind_account && this.bind_account.phone == ''
    },
    oldest_publish_sn() {
      return this.comment_list.length > 0
        ? this.comment_list[this.comment_list.length - 1].publish_sn
        : "";
    },
    is_ok_user(){
      let user = this.post && this.post.user
      return user && user.is_verified == 1 && user.is_not_rec == 0
    }
  },
  mounted() {
    let id = this._uid
    this.$bus.$on("modal_comment_publish", data => {
      if (data.call_uid != id) {
        return false;
      }
      if (data.type == "reply") {
        this.publish_reply(data.comment);
        return false;
      }
      if (data.type == "comment") {
        this.content = data.content;
        this.publish_comment();
        return false;
      }
    });
    if (this.comment.comment_id) {
      this.extend_watch_node(this.comment_list);
    }
  },
  beforeDestroy() {
    this.$bus.$off("modal_comment_publish");
  },
  methods: {
    change_lile_count(comment_id, type) {
      this.comment_list.forEach((v, k) => {
        if (v.comment_id == comment_id) {
          if (type == "like") {
            v.like_count++;
            v.has_like = 1;
          }
          if (type == "unlike") {
            v.like_count--;
            v.has_like = 0;
          }
        }
      });
    },
    async delete_comment(comment_id) {
      let re = await this.$mixin_confirm({title:'确认删除这条评论？'})
      if (!re) {
        return false;
      }
      if (this.$http.is_run(POST_COMMENT_DELETE)) {
        return false;
      }

      let data = await this.$http.$axios(POST_COMMENT_DELETE, {
        comment_id: comment_id
      });
      this.$notify({
        title: data.em,
        group: data.ec == 200 ? "success" : "error"
      });
      if (data.ec != 200) {
        return false;
      }
      let index = this.comment_list.findIndex(v => v.comment_id == comment_id);
      this.comment_list.splice(index, 1);
    },
    async publish() {
      if (this.$http.is_run(POST_COMMENT_PUBLISH)) {
        return false;
      }

      let data = await this.$http.$axios(POST_COMMENT_PUBLISH, this.post_data);
      this.$notify({
        title: data.em,
        group: data.ec == 200 ? "success" : "error"
      });
      if (data.ec != 200) {
        return false;
      }
      this.$modal.hide("ModalComment");
      this.$emit("publish_success");
      return data;
    },
    async publish_comment() {
      //发布评论
      this.post_data = {
        post_id: this.post.post_id,
        content: this.content
      };
      let data = await this.publish();
      if (data) {
        this.content = "";
        data.data.comment = Object.assign(
          data.data.comment,
          this.new_watch_node
        );
        this.comment_list.unshift(data.data.comment); //回填内容
      }
    },
    async publish_reply(comment) {
      //发布回复
      this.post_data = {
        post_id: this.post.post_id,
        content: comment.reply_content,
        reply_comment_id: comment.comment_id
      };
      let data = await this.publish();
      if (data) {
        comment = Object.assign(comment, this.new_watch_node);
        if (!this.is_hide_reply) {
          data.data.comment = Object.assign(
            data.data.comment,
            this.new_watch_node
          );
          this.comment_list.unshift(data.data.comment); //回填内容
        }
      }
    },
    async get_comment(post_data) {
      //可供 外组件调用
      if (this.$http.is_run(GET_COMMENT_GET_LIST)) {
        return false;
      }
      this.is_loading = true;
      let data = await this.$http.$axios(GET_COMMENT_GET_LIST, post_data);
      this.is_loading = false;
      if (data.ec != 200) {
        this.$notify({
          title: data.em,
          group: "error"
        });
        return false;
      }
      let list = data.data.list;
      if (data.data.hot_list) {
        this.hot_list = this.hot_list.concat(data.data.hot_list);
        list = this.hot_list.concat(list);
      }
      this.extend_watch_node(list);
      this.comment_list = this.comment_list.concat(list);
      this.has_more = data.data.has_more;
    },
    load_more() {
      this.get_comment({
        post_id: this.post.post_id,
        publish_sn: this.oldest_publish_sn,
        type: "old"
      });
    },
    extend_watch_node(comment_list) {
      //添加观察节点
      comment_list.forEach((v, k) => {
        if (typeof v.is_show_reply == "undefined") {
          this.$set(v, "is_show_reply", false);
          this.$set(v, "reply_content", "");
        }
      });
    },
    // async get_notice_comment(post_data){ //可供 外组件调用
    //     if(this.$http.is_run(POST_MY_NOTICE)){
    //         return false
    //     }
    //     let data = await this.$http.$axios(POST_MY_NOTICE, post_data)
    //     if(data.ec != 200){
    //         this.$notify({
    //             title: data.em,
    //             group: 'error',
    //         })
    //         return false;
    //     }
    //     this.comment_list = this.comment_list.concat(data.data.list)
    // },
    like_success(data) {
      this.change_lile_count(data.comment_id, "like");
    },
    unlike_success(data) {
      this.change_lile_count(data.comment_id, "unlike");
    },
    comment_like_success() {
      this.post.like_count++;
      this.post.has_like = !this.post.has_like;
    },
    comment_unlike_success() {
      this.post.like_count--;
      this.post.has_like = !this.post.has_like;
    },
    collect_success() {
      this.post.has_mark = 1;
    },
    uncollect_success() {
      this.post.has_mark = 0;
    },
    open_reply(comment) {
      if (!this.session_user) {
        this.mixin_go_login();
        return false;
      }
      if (this.browser_size == "small") {
        this.open_modal_comment("reply", comment);
        return false;
      }
      // console.log(comment.is_show_reply)
      comment.is_show_reply = true;
      // console.log(comment.is_show_reply)
      //   console.log(comment);
      // console.log(comment);
    },
    close_reply(comment) {
      comment.is_show_reply = false;
    },
    async open_modal_comment(type, comment) {
      if(this.session_user){
        if(this.no_bind_phone && this.ENV.is_abroad != 1 && !this.is_ok_user){
          this.$bus.$emit(`NEED_BIND_PHONE`);
          return false;
        }
        if(this.no_bind_user){
            this.$bus.$emit(`NEED_BIND_PHONE_IN_WECHAT`);
            return false;
        }
      }
      
      if (this.browser_size == "small") {
        this.$modal.show(
          () => import("@/components/ModalComment"),
          {
            title: type == "comment" ? "评论" : "回复",
            placeholder:
              type == "comment" ? "你的评论…" : `回复 ${comment.user.name}`,
            type: type,
            call_uid: this._uid,
            comment: comment
          },
          {
            clickToClose: false,
            classes: "v--modal-comment v--modal",
            height: "100%",
            width: "100%",
            adaptive: true,
            name: "ModalComment"
          }
        );
      }
    }
  }
};
</script>

<style lang="stylus" scoped>
.vm-comment {
    .gl-textarea {
        padding: px2rem(5) 0 px2rem(10) 0;
        padding: 0;
        border-width: 0 0 1px 0;
    }

    .load-more-box {
        padding-top: px2rem(16);
        margin-top: px2rem(16);
        border-top: 1px solid $black-1;
    }

    .load-box {
        padding-top: px2rem(7);
    }

    .vm-avatar /deep/ {
        &.comment-item {
            .avatar-name {
                color: $purple;
                font-weight: 600;
            }
        }
    }

    .vm-like /deep/ {
        .afd-heart {
            color: $black-3;
        }
    }

    .split-line-box {
        height: px2rem(30);
        margin-top: px2rem(10);
        position: relative;

        .line {
            width: 100%;
            position: absolute;
            top: 50%;
        }

        .t-box {
            background: $white;
            position: absolute;
            left: 50%;
            top: 50%;
            transform: translate(-50%, -50%);
            padding: px2rem(2) px2rem(10);
            z-index: 1;
        }
    }
    @media (display-mode: fullscreen), (display-mode: standalone){
      .toolbar {
        padding-bottom: $afd-safe-area-bottom;
      }
    }

    @media (max-width: $width-mobile) {
        .toolbar {
            position: fixed;
            bottom: 0;
            left: 0;
            width: 100%;
            background: $white;
            height: 64px;
            display: flex;
            align-content: center;
            z-index: 1;
            box-shadow: 0 _px2rem(4) px2rem(10) $black-2;

            .gl-textarea {
                border: 0;
                line-height: 27px;
            }
            .vm-avatar{
              margin-left:16px;
            }

            .action-box {
                flex-shrink: 0;
                margin-right:16px;
            }

            .vm-share /deep/ {
                .afd-share {
                    color: $purple;
                }
            }
        }
    }
}
</style>
